<div class="reset-password-container">

  <div class="reset-password-instructions">
    {{getString('resetPasswordInstructions')}}
  </div>

  <div class="form-field">
    <app-input-field [type]="'email'" [placeholder]="getString('emailAddress')" [autocomplete]="'email'" [name]="'email'" (valueChanged)="onEmailChange($event)"></app-input-field>
  </div>
  <div class="message-container">
    <div *ngIf="invalidEmail" class="red-text">{{getString('invalidEmail')}}</div>
    <div *ngIf="serverError" class="red-text">{{serverMessage}}</div>
  </div>

  <button class="submit-button blue-button" type="button" (click)="submit()">{{getString('submit')}}</button>

  <div *ngIf="showSuccess" class="success-container">

    <img alt="" class="check-icon" src="./assets/images/blue_check_icon.png">

    <div>
      {{getEmailSentTo()}}
    </div>

    <div>
      {{getString('pleaseCheckYourEmails')}}
    </div>

    <button class="ok-btn blue-button" type="button" (click)="okClicked()">{{getString('ok')}}</button>

  </div>

</div>

